// 甜蜜惩罚漫画 剧情追踪站 — 站点数据
// 说明：以下为围绕本作剧情整理的追更梳理内容，随连载持续更新

export const SITE_NAME = '甜蜜惩罚漫画追踪站';

export const navLinks = [
  { id: 'plot', label: '剧情主线' },
  { id: 'characters', label: '角色盘点' },
  { id: 'chapters', label: '分话解析' },
  { id: 'clues', label: '结局线索' },
  { id: 'faq', label: '常见问题' },
  { id: 'about', label: '关于本站' },
  { id: 'contact', label: '联系我们' },
];

export const heroStats = [
  { value: '120+', label: '已更新分话' },
  { value: '6', label: '主要剧情篇章' },
  { value: '4', label: '核心角色档案' },
  { value: '9.2', label: '读者口碑评分' },
];

export const arcList = [
  {
    tag: '序章',
    title: '重逢之前',
    period: '第 1–9 话',
    desc: '林晚以全新身份重返商界，与当年一手将她推入深渊的沈氏集团正面相遇。开篇以冷冽的商场博弈拉开帷幕，也埋下两人纠缠多年的伏笔。',
    points: ['五年后的华丽转身', '第一场正面交锋', '旧日创伤的碎片浮现'],
  },
  {
    tag: '第一章',
    title: '温柔陷阱',
    period: '第 10–24 话',
    desc: '沈斯言步步紧逼，表面强势掌控，实则在细节里露出破绽。林晚将计就计，在若即若离之间试探对方的真心，两人关系进入微妙的拉锯。',
    points: ['被安排的「偶遇」', '试探与反试探', '第一次近距离相拥'],
  },
  {
    tag: '第二章',
    title: '暗潮涌动',
    period: '第 25–41 话',
    desc: '当年阴谋的真凶逐渐浮出水面，顾念与江屿两条支线同时推进。感情线与悬疑线交织，让甜蜜与危机并存，剧情迎来第一个爆发点。',
    points: ['真凶线索出现', '顾念身世揭秘', '沈斯言的选择'],
  },
  {
    tag: '第三章',
    title: '甜蜜惩罚',
    period: '第 42–60 话',
    desc: '摊牌时刻到来，曾经被辜负的林晚终于问出那句「你后悔过吗」。所谓惩罚，其实是一场彼此救赎的双向奔赴，甜蜜与酸涩在此刻达成和解。',
    points: ['雨夜摊牌', '当年的真相', '双向奔赴的开端'],
  },
  {
    tag: '第四章',
    title: '结局之前',
    period: '第 61 话起',
    desc: '主线逐渐收束，读者最关心的结局线索正在密集释放。谁将付出代价、谁会被原谅、两人的归宿如何，本追踪站将持续跟进与复盘。',
    points: ['伏笔集中回收', '角色命运走向', 'HE 线索追踪'],
  },
];

export const characters = [
  {
    name: '林晚',
    role: '女主角 · 商界新锐',
    tagline: '从天真少女到步步为营的归来者',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20portrait%20illustration%20of%20a%20graceful%20young%20woman%20with%20long%20dark%20hair%20and%20a%20gentle%20yet%20determined%20expression%2C%20wearing%20a%20soft%20cream%20dress%2C%20warm%20rose%20toned%20painterly%20background%20with%20delicate%20floral%20accents%2C%20elegant%20manga%20character%20key%20visual%2C%20cinematic%20soft%20lighting%2C%20no%20text&width=600&height=760&seq=sp-char-01&orientation=portrait',
    desc: '五年后携全新身份归来，隐忍与锋利并存。她的「惩罚」从不是报复的狠戾，而是把当年被夺走的人生，一点一点赢回来的坚定。',
    traits: ['坚毅', '隐忍', '深情'],
    arc: '复仇与救赎的核心人物',
  },
  {
    name: '沈斯言',
    role: '男主角 · 集团掌权人',
    tagline: '看似掌控一切，实则深藏执念',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20portrait%20illustration%20of%20a%20composed%20young%20man%20in%20a%20dark%20tailored%20suit%20with%20a%20subtle%20warm%20smile%2C%20deep%20crimson%20and%20gold%20painterly%20background%2C%20elegant%20manga%20character%20key%20visual%2C%20cinematic%20soft%20lighting%2C%20no%20text&width=600&height=760&seq=sp-char-02&orientation=portrait',
    desc: '表面冷酷疏离、杀伐决断，心底却藏着多年不曾言说的悔意与执念。他对林晚的每一步「惩罚」，都是想把她重新拉回身边的笨拙告白。',
    traits: ['克制', '偏执', '深情'],
    arc: '感情线另一极，结局关键变量',
  },
  {
    name: '顾念',
    role: '林晚闺蜜 · 治愈担当',
    tagline: '关键时刻的暖心支线',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20portrait%20illustration%20of%20a%20cheerful%20young%20woman%20with%20short%20bob%20hair%20and%20a%20bright%20warm%20smile%2C%20blush%20pink%20painterly%20background%20with%20subtle%20sparkles%2C%20cute%20manga%20character%20key%20visual%2C%20soft%20lighting%2C%20no%20text&width=600&height=760&seq=sp-char-03&orientation=portrait',
    desc: '永远站在林晚身边的最强后盾，用温柔化解她的锋芒。身世线索与主线阴谋深度绑定，是解开当年真相的重要钥匙。',
    traits: ['温暖', '忠诚', '通透'],
    arc: '身世线牵动主线真相',
  },
  {
    name: '江屿',
    role: '沈斯言好友 · 亦敌亦友',
    tagline: '藏有心事的复杂人物',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20portrait%20illustration%20of%20a%20thoughtful%20young%20man%20with%20glasses%20and%20neat%20hair%2C%20gentle%20expression%2C%20amber%20and%20cream%20painterly%20background%2C%20refined%20manga%20character%20key%20visual%2C%20soft%20cinematic%20lighting%2C%20no%20text&width=600&height=760&seq=sp-char-04&orientation=portrait',
    desc: '与沈斯言亦敌亦友，立场摇摆、心思难测。他对林晚的态度微妙，究竟是盟友、对手还是又一段未言说的情愫，成为读者热议焦点。',
    traits: ['精明', '矛盾', '神秘'],
    arc: '情感与立场双线摇摆',
  },
];

export const chapterList = [
  {
    no: '第 01 话',
    title: '归来的晚风',
    tag: '开篇',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20scene%20illustration%20of%20an%20elegant%20restaurant%20candlelit%20dinner%20with%20a%20man%20and%20woman%20sharing%20a%20tender%20moment%2C%20warm%20golden%20and%20rose%20lighting%2C%20painterly%20manga%20storyboard%20style%2C%20intimate%20atmosphere%2C%20no%20text&width=820&height=520&seq=sp-ch-01&orientation=landscape',
    summary: '林晚一身干练西装踏入沈氏大楼，旧识的错愕与她的从容形成鲜明对比。开篇即定下「复仇归来」的基调，冷冽中藏着柔软。',
    highlight: '五年后的首次对视',
  },
  {
    no: '第 18 话',
    title: '心跳越界',
    tag: '感情升温',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20scene%20illustration%20of%20a%20rainy%20city%20street%20at%20night%20with%20a%20man%20offering%20his%20umbrella%20to%20a%20woman%2C%20glowing%20warm%20streetlights%20reflecting%20on%20wet%20pavement%2C%20deep%20rose%20and%20amber%20palette%2C%20emotional%20manga%20scene%2C%20no%20text&width=820&height=520&seq=sp-ch-02&orientation=landscape',
    summary: '雨夜共撑一伞，沈斯言那句「我后悔过」脱口而出，又仓促收回。暧昧与试探在这一话达到高峰，被读者奉为感情线转折名场面。',
    highlight: '雨夜名场面',
  },
  {
    no: '第 42 话',
    title: '摊牌时刻',
    tag: '剧情爆发',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20scene%20illustration%20of%20a%20spring%20garden%20with%20cherry%20blossoms%20where%20two%20figures%20reach%20toward%20each%20other%2C%20soft%20pink%20and%20gold%20light%2C%20painterly%20romance%20manga%20scene%2C%20dreamy%20atmosphere%2C%20no%20text&width=820&height=520&seq=sp-ch-03&orientation=landscape',
    summary: '当年真相在樱花树下摊开，误会与隐瞒被逐一解开。林晚的质问与沈斯言的剖白，让这段「甜蜜惩罚」终于有了双向奔赴的实感。',
    highlight: '真相大白 + 双向奔赴',
  },
  {
    no: '第 61 话',
    title: '结局将至',
    tag: '收束中',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20scene%20illustration%20of%20a%20couple%20walking%20together%20under%20warm%20golden%20sunset%20light%20toward%20a%20distant%20skyline%2C%20floating%20rose%20petals%20in%20the%20air%2C%20painterly%20romance%20manga%20ending%20scene%2C%20warm%20and%20hopeful%20atmosphere%2C%20no%20text&width=820&height=520&seq=sp-ch-04&orientation=landscape',
    summary: '主线进入收束期，多条伏笔开始集中回收。谁的命运将被改写、谁又会被原谅，结局走向成为全网读者此刻最关心的话题。',
    highlight: '伏笔集中回收',
  },
];

export const clueList = [
  {
    title: 'HE 信号渐强',
    icon: 'ri-heart-3-fill',
    tone: 'primary',
    desc: '主线后半程，两人互动逐渐从试探转向并肩。官方分话标题与封面构图多次出现双向奔赴意象，读者普遍认为幸福结局概率持续走高。',
    level: '高可信',
  },
  {
    title: '真凶伏笔待回收',
    icon: 'ri-focus-3-line',
    tone: 'accent',
    desc: '顾念身世与当年阴谋仍留有未解细节，编剧并未急于交代全部答案。这些线索大概率会在结局前集中引爆，影响整体走向。',
    level: '关键变量',
  },
  {
    title: '江屿立场成谜',
    icon: 'ri-question-mark',
    tone: 'secondary',
    desc: '江屿对林晚的态度始终模糊，是救赎性的成全，还是另一段执念？他的最终选择可能左右主线结局的落点，值得持续观察。',
    level: '待观察',
  },
  {
    title: '「惩罚」的真意',
    icon: 'ri-leaf-line',
    tone: 'primary',
    desc: '「甜蜜惩罚」的题眼正逐渐浮出水面——惩罚未必是报复，而是以温柔的方式，逼彼此直面当年的伤口，最终达成和解。',
    level: '主题升华',
  },
];

export const faqList = [
  {
    q: '《甜蜜惩罚》漫画目前的更新频率是怎样的？',
    a: '本作处于连载中后期，通常保持稳定更新节奏，主线已进入收束篇章。本站会第一时间跟进最新分话，并在剧情线、角色线与结局线索板块同步更新梳理内容，方便读者追更不迷路。',
  },
  {
    q: '男女主角最后会走向幸福结局（HE）吗？',
    a: '从当前主线释放的信号来看，两人互动已从试探转向并肩，题目「甜蜜惩罚」的意象也在逐步由「报复」过渡到「救赎与和解」。具体走向仍受未回收伏笔影响，本站「结局线索」板块会持续追踪并更新分析。',
  },
  {
    q: '沈斯言对林晚到底是真心还是执念？',
    a: '这是目前读者讨论最热烈的话题之一。综合分话表现，沈斯言对林晚既有多年执念，也在后期逐渐流露出真正的悔意与深情。「甜蜜惩罚」的核心，正是这种执念在碰撞中转化为双向奔赴的过程。',
  },
  {
    q: '顾念的身世与主线阴谋有什么关系？',
    a: '顾念身世是解开当年真相的重要线索，其支线剧情与主线阴谋深度绑定。后续章节预计会对这部分伏笔进行集中回收，直接关系到主要角色的命运走向。',
  },
  {
    q: '江屿这个角色在结局中会起什么作用？',
    a: '江屿作为亦敌亦友的存在，立场摇摆、心思难测，他的最终选择可能成为影响主线结局的关键变量。建议读者留意他与沈斯言、林晚之间的每次互动细节。',
  },
];

export const testimonials = [
  {
    name: '追更人小橙',
    role: '连载读者',
    text: '以前追这部总是剧情线理不清，这个站的「剧情主线」板块把每个篇章的关键节点都标得清清楚楚，追更体验好了不止一倍。',
    rating: 5,
  },
  {
    name: '阿黎',
    role: '角色粉',
    text: '角色盘点和分话解析都写得很走心，尤其对沈斯言感情线的解读，感觉作者是真的在认真追更分析，不是随便搬运。',
    rating: 5,
  },
  {
    name: '栗子派',
    role: '结局党',
    text: '「结局线索」板块一直在持续更新，会把最新分话里容易被忽略的伏笔都拎出来讲，对猜结局太有帮助了。',
    rating: 5,
  },
];

export const footerColumns = [
  {
    title: '追更栏目',
    links: [
      { id: 'plot', label: '剧情主线' },
      { id: 'characters', label: '角色盘点' },
      { id: 'chapters', label: '分话解析' },
      { id: 'clues', label: '结局线索' },
    ],
  },
  {
    title: '阅读帮助',
    links: [
      { id: 'faq', label: '常见问题' },
      { id: 'about', label: '关于本站' },
      { id: 'contact', label: '联系我们' },
    ],
  },
];